/**
 * Created by gilk on 10/08/17.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var DateUtility = require("utils/DateUtility");

    var SkillListComparators = [];

    function moduleDefinition (LEUserManagement, LE, Backbone, Marionette, $, _) {
        SkillListComparators = [
            {
                name:"responseTime",
                func:function(model){
                    return model.getSlaDefaultResponseTime();
                }
            }

        ];
    }

    LE.module("LEUserManagement", moduleDefinition);

    return SkillListComparators;
});
